import { ImageSource } from '@news-mono/web-common'
import { ImageV4DTO, KnownRatioToRatio } from '@west-australian-newspapers/publication-types'

/**
 * Convert ImageV4DTO poster to ImageSource with original + optional 16:9 crop.
 */
export const mapPosterImageDtoToImageSource = (
    posterImage?: ImageV4DTO | null,
): ImageSource | undefined => {
    if (!posterImage || !posterImage.reference) {
        return undefined
    }

    const ratio =
        typeof posterImage.ratio === 'object'
            ? posterImage.ratio
            : KnownRatioToRatio[posterImage.ratio] || { width: 16, height: 9 }

    const base = {
        reference: posterImage.reference,
        width: posterImage.width ?? 0,
        height: posterImage.height ?? 0,
        ratio,
    }

    return {
        altText: posterImage.altText || posterImage.captionText || undefined,
        crops: {
            original: base,
            '16:9':
                posterImage.ratio === '16:9' ||
                posterImage.ratio === undefined ||
                posterImage.ratio === null ||
                (ratio.width === 16 && ratio.height === 9)
                    ? base
                    : undefined,
        },
    }
}
